"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalance = getBalance;
async function getBalance(machineRepo, machineId) {
    return await machineRepo.getBalance(machineId);
}
